<template>
    <v-card>
        <v-btn class="close default v-btn--simple"
               @click="closeTournament">
            <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-text>
            <material-card
                    class="card-tabs"
                    color="#004D40">
                <v-flex
                        slot="header"
                >
                    <v-tabs v-model="tabs"
                            color="transparent"

                            slider-color="white">

                        <v-tab class="mr-3">
                            
                            Инфо
                        </v-tab>
                        <v-tab class="mr-3">
                            <v-icon class="mr-2">mdi-format-list-checkbox</v-icon>
                            Продукция
                        </v-tab>
                        <v-tab class="mr-3">
                            <v-icon class="mr-2">mdi-format-list-checkbox</v-icon>
                            Дилеры
                        </v-tab>

                    </v-tabs>
                </v-flex>

                <v-tabs-items>
                    <v-tab-item>
                        <div class="tab-products">
                            <Tournament :TournamentID="TournamentID" :closeTournament="closeTournament" v-if="tabs===0"/>
                            <TournamentProducts :TournamentID="TournamentID" v-else-if="tabs===1"/>
                            <TournamentDealers :TournamentID="TournamentID" v-else-if="tabs===2"/>
                        </div>
                    </v-tab-item>

                </v-tabs-items>

            </material-card>
        </v-card-text>
    </v-card>
</template>
<script>
    import Tournament from "./core/Tournaments/Tournament";
    import TournamentProducts from "./core/Tournaments/TournamentProducts";
    import TournamentDealers from "./core/Tournaments/TournamentDealers";
    export default {
        name: 'TournamentCard',
        components: {TournamentProducts,TournamentDealers, Tournament},
        data() {
            return {
                tabs: -1
            }
        },
        methods: {},
        mounted() {
            this.tabs = 0;
        },
        props: ['TournamentID', 'closeTournament'],
    }
</script>

<style>
    .tab-products {
        min-height: 70vh;

    }
</style>